import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=496acc27&scoped=true"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=496acc27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496acc27",
  null
  
)

export default component.exports